import { useEffect, useState } from "react"
import { Alert, Badge, Button, Card, CardBody, CardHeader, Container, Table } from "reactstrap"
import Utils from "../../Utils"
import { Link } from "react-router-dom"
import ModalNotificar from "../../modals/ModalNotificar"
import FormNotificar from "../../components/FormNotificar"
import ModalEditarUsuario from "../../modals/ModalEditarUsuario"
import { useSelector } from "react-redux"

const RolBadge = ({ user, cambiarRol }) => {

    const { rol, color, nextRol } = Utils.rolInfo(user.Rol)

    const currentUser = useSelector(({ usuario }) => usuario.currentUser)

    const _currentUser = (currentUser == null) ? {} : currentUser

    const canChange = () => {
        if(_currentUser.Rol != "a" || user.Rol == "a") {
            return false
        }
        return true
    }

    const handleEditClick = () => {
        if(canChange() == true) {
            // vlaidamos la confirmacion del suuario
            if(window.confirm("Realmente deesea cambiar el rol?") == true) {
                cambiarRol(user.idUsuario, nextRol)
            }
        }
    }

    return(
        <Badge className={canChange() == true ? "cursorLink" : null} color={color} onClick={handleEditClick}>{rol}</Badge>
    )
}

const ListarUsuarios = () => {

    const [user, setUser] = useState(null)

    const [isOpenNotificar, setIsOpenNotificar] = useState(false)

    const openModalNotificar = _user => {
        setUser(_user)
        setIsOpenNotificar(true)
    }

    const closeModalNotificar = () => {
        setIsOpenNotificar(false)
    }

    const [isOpenEditar, setIsOpenEditar] = useState(false)

    const openModalEditar = _user => {
        setUser(_user)
        setIsOpenEditar(true)
    }

    const closeModalEditar = () => {
        setIsOpenEditar(false)
    }

    const [usuarios, setUsuarios] = useState(null)

    const fetchUsuarios = async () => {
        try {
            const { data } = await Utils.API.ListarUsuarios()
            setUsuarios( data)
            //
        } catch(err) {
            Utils.AlertError(err, "No se pudo cargar la lista de usuarios")
        }
    }

    const toggleActivo = async ({ Activo, idUsuario }) => {
        let msg = `Estás seguro q desas desactivar el usuario?`
        if(Activo == false) {
            msg = `Estás seguro q desas activar el usuario?`
        }
        // promp
        if(window.confirm(msg) == false) {
            return;
        }
        // try
        try {
            await Utils.API.SetUsuarioActivo(idUsuario, !Activo)
            fetchUsuarios()
        } catch(err) {
            Utils.AlertError(err, `No se pudo cambiar el estado activo del usuario`)
        }
    }

    const cambiarRol = async (idUsuario, rol) => {
        try {
            await Utils.API.SetUsuarioRol(idUsuario, rol)
            fetchUsuarios()
        } catch(err) {
            Utils.AlertError(err, "No se pudo modificar el rol del usuario")
        }
    }

    useEffect(() => {
        fetchUsuarios()
    }, [])

    return(
        <Container>
            <Card className="my-3">
                <CardHeader className="h3">Notificar Usuarios</CardHeader>
                <CardBody>
                    <FormNotificar />
                </CardBody>
            </Card>
            {(usuarios == null) ?
                <Alert className="text-center h3" color="info">Cargando...</Alert>
                :
                <>
                    <Table hover className="my-2 text-center" bordered>
                        <thead>
                            <tr className="table-info">
                                <th>Rol</th>
                                <th>DNI</th>
                                <th>Nombre</th>
                                <th>Celular</th>
                                <th>Registro</th>
                                <th>Propiedades</th>
                                <th>Acciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            {usuarios.map(user => (
                                <tr key={user.idUsuario}>
                                    <th>
                                        <RolBadge user={user} cambiarRol={cambiarRol} />
                                    </th>
                                    <th scope="row">{user.DNI}</th>
                                    <td>{user.Nombre}</td>
                                    <td>{user.Celular}</td>
                                    <td>{Utils.dayjs(user.FechaRegistro).format("L")}</td>
                                    <td>{user.CantidadPropiedades}</td>
                                    <td>
                                        <Button onClick={() => {  toggleActivo(user) }} size="sm" outline color={user.Activo ? "danger" : "success"}>{user.Activo ? "Desactivar" : "Activar"}</Button>
                                        {(user.CantidadPropiedades > 0) &&
                                            <Link to={`/Ventas/Pagos/${user.idUsuario}`} className="m-2 btn btn-outline-success btn-sm">
                                                <i className="fa-solid fa-file-invoice-dollar"></i> Pagos
                                            </Link>
                                        }
                                        <Button size="sm" outline onClick={() => { openModalEditar(user) }} className="m-2">
                                            <i className="fa-solid fa-user-pen"></i> Modificar
                                        </Button>
                                        <Button size="sm" color="primary" onClick={() => { openModalNotificar(user) }} outline className="m-2">
                                            <i className="fa-regular fa-bell"></i> Notificar
                                        </Button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </>
            }

            <ModalNotificar
                user={user}
                isOpen={isOpenNotificar}
                closeModal={closeModalNotificar}
            />

            <ModalEditarUsuario
                user={user}
                isOpen={isOpenEditar}
                closeModal={closeModalEditar}
                fetchUsuarios={fetchUsuarios}
            />
        </Container>
    )
}

export default ListarUsuarios